<script>
    import {onMount} from 'svelte';

    import store from '../../../Stores/sede-store';

    import {url, goto} from '@sveltech/routify';

    import Loading from "../../../Components/UI/Loading.svelte";
    import Error from "../../../Components/UI/Error.svelte";
    import Titulo from "../../../Components/UI/Titulo.svelte";
    import Migas from "../../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../../Components/UI/Migas/Miga.svelte";
    import Formulario from "../../../Components/Sedes/Edicion/Formulario.svelte";

    export let id;

    onMount(() => store.cargar(id));

    let sede, error, nombre;
    $: nombre = sede.nombre;

    $: sede = $store.sede;
    $: error = $store.error;
</script>

<svelte:head>
    <title>Edición de {nombre}</title>
</svelte:head>

<style>
    h2 .material-icons {
        font-size: 2.5em;
        vertical-align: bottom;
        line-height: 1;
    }
</style>

<Migas>
    <Miga url={$url('/sedes')}>Sedes</Miga>
    {#if sede}
        <Miga url={$url(`/sedes/${id}`)}>{nombre}</Miga>
        <Miga actual>Edición de sede</Miga>
    {/if}
</Migas>

<Titulo>Edición de sede</Titulo>

{#if $store.cargando}
    <Loading/>
{:else if error}
    <Error mensaje={error} on:cancel={() => error = null}/>
{:else if sede }
    <Formulario titulo="Edición de {nombre}" on:enviado={() => $goto('/sedes')} />
{/if}